import styled from '@emotion/styled'
import { css } from '@emotion/react'

const gridStyles = ({ theme }) => css`
  label: grid;

  display: grid;
  grid-gap: ${theme.spacings.kilo};

  margin: ${theme.spacings.giga} ${theme.spacings.kilo};
`

export const Grid = styled('div')(gridStyles)
